import React from 'react';
import Script from "next/script"
import DOMPurify from 'isomorphic-dompurify';

class SEOProduct extends React.PureComponent {
  render() {
    const props = this.props;
    let { productData, bvData, bvReviewData, locale } = props;
    var seoConfig = require('../../../data/' + locale + '/seo.json');
    const constants = require(`../../../constants/messages/${locale}`);
    let reviews = ''

    bvReviewData &&
      bvReviewData.length > 0 &&
      (reviews = `"review": {
          "@type": "${constants.typeReviewSEOProduct}",
            "author": "${bvReviewData[0].UserNickname}",
             "datePublished": "${bvReviewData[0].SubmissionTime.substring(
               0,
               10
             )}",
             "description": "${bvReviewData[0].ReviewText}",
             "reviewRating": {
               "@type": "${constants.typeRatingSEOProduct}",
               "bestRating": "${constants.bestRatingSEOProduct}",
               "ratingValue": "${
                 bvReviewData[0].Rating
                   ? bvReviewData[0].Rating
                   : constants.ratingValueSEOProduct
               }",
               "worstRating": "${constants.worstRatingSEOProduct}"
              }
          },`);
      
      let aggregateRating = `"aggregateRating": {
          "@type": "${constants.AggregateRatingSEOProduct}",
          "ratingValue": "${bvData?.ReviewStatistics?.AverageOverallRating || 0}",
          "reviewCount": "${bvData?.TotalReviewCount || 0}",
          "bestRating": "${constants.bestRatingSEOProduct}",
          "worstRating": "${constants.worstRatingSEOProduct}"
        },`
        
    return (
      <>
        <Script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:DOMPurify.sanitize( `
            { 
                "@context": "${seoConfig.context}", 
                "@type": "Product", 
                "name": "${productData?.productName.replace(/(\r\n|\n|\r)/gm, " ")}",
                "description": "${productData?.shortDescription &&
                  productData?.shortDescription.replace(/(\r\n|\n|\r)/gm, "")}",
                "image": "${productData?.heroImage &&
                  productData?.heroImage.url}",
                "sku": "${productData && productData.gtin}",
                "gtin8": "${productData && productData.gtin}",
                ${reviews}
                ${aggregateRating}
                "brand": {
                  "@type": "Brand",
                  "name": "${constants.SEOProductName}"
                }
            }`),
          }}
        />
      </>
    );
  }
}

export default SEOProduct;